import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { classes } from './Cover.st.css';
var Cover = function (props) { return (React.createElement("div", { style: {
        backgroundImage: "url(" + (props.context.cover || props.fallbackCover) + ")",
    }, className: classes.cover + " " + props.className, "data-hook": props.dataHook })); };
Cover.displayName = 'Cover';
Cover.defaultProps = {
    className: '',
    dataHook: '',
    fallbackCover: '',
};
export default withPlaybackContext(Cover);
//# sourceMappingURL=Cover.js.map